module.exports = __webpack_public_path__ + "static/media/captain_male.2107ef73.png";